export enum ApiClientType {
  Unknown = 0,
  WpfErpUser = 1,
}
